import Vue from 'vue'
import Router from 'vue-router'
import Container from '@/components/Container/Container'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Container',
      component: Container
    }/*,
    {
      path: '/about',
      name: 'about',
      component: () =>
        import(/!* webpackChunkName: "about" *!/ './views/About.vue')
    }*/
  ]
})
